export const validateVin = (value: string) => {
  const regex = /^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17,18}$/
  const space = /^[a-zA-Z0-9_]*$/
  return regex.test(value) && space.test(value)
}
